const NAVY = "#221C5D";
const ORANGE = "#E56A22";

/**
 * Destek listesi ekranlarının ortak stilleri (Destek Yönetimi + Destek Taleplerim).
 *
 * İki ekran aynı tasarım dilini paylaşır; sınıflar `.tickets-modern` altında toplandığı
 * için sayfayı saran kapsayıcıya bu sınıfı vermek yeterlidir. Panelin diğer liste
 * ekranlarında olduğu gibi stil, sayfanın kendi <style> bloğuyla enjekte edilir.
 */
export const ticketListStyles = `
  .tickets-modern .filter-bar {
      display: flex; flex-wrap: wrap; gap: .6rem; align-items: center;
      padding: 1rem 1.25rem; border-bottom: 1px solid #e9ecef;
  }
  .tickets-modern .filter-search { flex: 1 1 260px; min-width: 200px; max-width: 380px; }
  .tickets-modern .filter-select { flex: 0 0 auto; width: 170px; }
  .tickets-modern .table thead th {
      font-size: .78rem; font-weight: 700; letter-spacing: .02em;
      color: #64748b; text-transform: none; white-space: nowrap; background: #fff;
  }
  .tickets-modern .table tbody td { vertical-align: middle; font-size: .875rem; }
  .tickets-modern .ticket-subject { font-weight: 600; color: #1e293b; }
  .tickets-modern .ticket-no { font-size: .75rem; color: #94a3b8; }
  .tickets-modern .sort-th { cursor: pointer; user-select: none; }
  .tickets-modern .sort-th i { color: #b6bdc9; margin-left: .25rem; }

  .tickets-modern .corporate-pagination .page-link { color: ${NAVY}; border-color: ${ORANGE}; }
  .tickets-modern .corporate-pagination .page-item.active .page-link {
      background-color: ${NAVY}; border-color: ${NAVY}; color: #fff;
  }
  .tickets-modern .corporate-pagination .page-link:hover { border-color: ${NAVY}; color: ${NAVY}; }
`;

export const TICKET_NAVY = NAVY;
